import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "calendarCheck"
const CalendarCheckIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m19 15 1.5-1.5.5.5 1 1-1 1-2 2-2 2-2 2-2-2-2.5-2.5L12 16l3 3 4-4Zm2-9v5.563a1.999 1.999 0 0 0-1.914.523l-.086.086V9H5v11h5.172l2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V2h2v2h8V2h2v2h1a2 2 0 0 1 2 2Zm-3.172 16L21 18.828V20a2 2 0 0 1-2 2h-1.172Z"
      />
    </svg>
  )
}
export default CalendarCheckIcon
